import React, { useState } from "react";
import Header from "../common/Header";
import Footer from "../common/Footer";
import {
  aboutimg,
  andriodimg,
  conceptimg,
  iosimg,
  iphoneimg,
  landingimg,
  mobileimg,
  ridesafety,
  service2img,
  service3img,
  service4img,
  service5img,
  service6img,
  serviceimg,
  star,
  testimonial2img,
  testimonial3img,
  testimonialimg,
} from "../assets/image";
import { Link } from "react-router-dom";
import {
  alert,
  bookimg,
  bookride,
  mandate,
  navigate,
  payimg,
  payment,
  rideimg,
  safety,
  starimg,
  userimg,
  userimg1,
  userimg2,
} from "../assets/icons";
import { Accordion } from "react-bootstrap";
import { MdArrowDropDown } from "react-icons/md";
import Slider from "react-slick";
import { GoArrowLeft, GoArrowRight } from "react-icons/go";

const Home = () => {
  const [propertyTab, setPropertyTab] = useState("Pre-Order");

  const rideArray = [
    {
      id: 1,
      img: bookimg,
      name: "Book",
      para: "Choose a ride and driver.",
    },
    {
      id: 2,
      img: rideimg,
      name: "Ride",
      para: "Travel with comfort to your destination.",
    },
    {
      id: 3,
      img: payimg,
      name: "Pay Directly",
      para: "Pay through cash or online platforms",
    },
  ];
  const driverArray = [
    {
      id: 1,
      img: alert,
      name: "Ride Alerts",
      para: "Receive real-time notifications for nearby rides.",
    },
    {
      id: 2,
      img: navigate,
      name: "Navigation",
      para: " Timely travel with smart routes and traffic updates",
    },
    {
      id: 3,
      img: payment,
      name: "Payments",
      para: "Receive secure payments and track earnings.",
    },
  ];
  const array = [
    {
      id: 1,
      img: serviceimg,
      name: "Book a Taxi",
      para: "Book a taxi in the most convenient way at the lowest rate in the market. ",
    },
    {
      id: 2,
      img: service2img,
      name: "Book an Ambulance",
      para: "Book an ambulance for fast, reliable, and safe transport to the nearest hospital. We’re available 24/7.",
    },
    {
      id: 3,
      img: service3img,
      name: "Book a Rental",
      para: "Select the best rental for your next trip from top-tier vehicles with quick booking and affordable rates.",
    },
    {
      id: 4,
      img: service4img,
      name: "Book a Shuttle",
      para: "Book your shuttle in just a few clicks. Enjoy comfortable and secure travel with timely pick-ups and drop-offs.",
    },
    {
      id: 5,
      img: service5img,
      name: "Book a Carpool",
      para: "Find the perfect carpool ride from our wide range of destinations and routes at low prices.",
    },
    {
      id: 6,
      img: service6img,
      name: "Book a Travel",
      para: "Book your travel with us for special deals and personalized travel experiences.",
    },
  ];
  const weArray = [
    {
      id: 1,
      img: bookride,
      name: "Book With Transparency ",
      para: "We allow riders to view drive ratings and feedback to enhance transparency and trust in the ride.",
    },
    {
      id: 2,
      img: safety,
      name: "Mandatory Checks",
      para: "The driver needs to go through background verification before being associated with Godide.",
    },
    {
      id: 3,
      img: mandate,
      name: "Safety Button",
      para: " We provide an in-app emergency button, which connects riders or drivers with local authorities during an emergency.",
    },
  ];
  const crousal = [
    {
      id: 1,
      img: testimonialimg,
      name: "Leslie Alexander",
      address: "SAN DIEGO, CA",
      para: "Godide has completely transformed my daily commute. The app is super user-friendly, and booking a ride just takes a few taps. I love that I can track my driver in real time and I can also see estimated fares which helps me plan my budget for the day. Godide allows me to schedule rides in advance and it has been wonderful for my business trips. The safety button feature gives me peace of mind while riding. ",
    },
    {
      id: 2,
      img: testimonial2img,
      name: "Jenny Wilson",
      address: "Mesa, New Jersey",
      para: "I have tried several ride-hailing services but Godide stands out due to its commitment to safety. It has transformed my daily commute because the app is easy to use and I travel without any worries knowing that the drivers are background-verified.",
    },
    {
      id: 3,
      img: testimonial3img,
      name: "Kristin Watson",
      address: "Allentown, New Mexico ",
      para: "Godide makes traveling easier and cost-saving with budget-friendly rides. I loved the transparency in fare estimates, and the drivers are also professional. Their ride-sharing option is too fantastic which saves both time and money.",
    },
  ];

  var settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    prevArrow: (
      <span>
        <GoArrowLeft />
      </span>
    ),
    nextArrow: (
      <span>
        <GoArrowRight />
      </span>
    ),
  };

  return (
    <div className="wrapper_landing_page">
      <Header />
      <section className="wrapper_home" id="home">
        <div className="container">
          <div className="wrap_landing">
            <div className="wrap_left_right">
              <div className="left_side">
                <h1>
                  The Smartest Way <br /> To Reach Your <br /> Destination
                </h1>
                <p>
                  More than a taxi. We offer online ride-sharing services.
                  Download
                  <span className="green_txt"> Godide App</span> and start
                  moving around city comfortably
                </p>
                <div className="wrap_app_redirection">
                  <Link
                    to={
                      "https://play.google.com/store/apps/details?id=com.ripenapps.godideride&hl=en"
                    }
                    target="_blank"
                  >
                    <img src={andriodimg} alt="" />
                  </Link>
                  <Link
                    to={"https://apps.apple.com/in/app/godiderider/id6504527583"}
                    target="_blank"
                  >
                    <img src={iosimg} alt="" />
                  </Link>
                </div>
              </div>
              <div className="right_side">
                <figure>
                  <img src={landingimg} alt="" />
                </figure>
              </div>
            </div>
            <div className="flex_bottom">
              <div className="wrap_testi_client">
                <img src={userimg1} alt="" />
                <img src={userimg2} alt="" />
                <img src={userimg} alt="" />
                <img src={starimg} alt="" />
                <p>
                  5.0 Happy Customer
                  <span>(10.2k Review by our customers)</span>
                </p>
              </div>
              <div className="taxi_ride">
                <p>More than a taxi. Online ride-sharing services. </p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="wrapper_download_rating">
        <div className="container">
          <div className="wrap_rating">
            <ul>
              <li>
                <p>
                  20K <span>+</span>
                </p>
                <span className="cstm_span">All Download</span>
              </li>
              <li>
                <p>
                  4.5 <span>+</span>
                </p>
                <span className="cstm_span">Overall Rating</span>
              </li>
              <li>
                <p>
                  10K <span>+</span>
                </p>
                <span className="cstm_span">Active User</span>
              </li>
            </ul>
            <figure>
              <img src={iphoneimg} alt="" />
            </figure>
          </div>
        </div>
      </section>
      <section className="wrapper_about spacing" id="about">
        <div className="container">
          <div className="wrap_about">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="wrap_content pe-4">
                  <span>About Us</span>
                  <h2 className="title_h2">
                    On-Demand Rides, Anytime, Anywhere.
                  </h2>
                  <p className="custom_p">
                    Godide is a leading ride-hailing services provider company
                    with a focus on providing online ride-sharing services. We
                    help people go anywhere, anytime with just a few taps on
                    their phone. From drivers with background verification to
                    in-app emergency button, safety is our first priority. The
                    Godide app connects millions of customers to drivers with
                    comfort and transparency. Founded with a vision to reshape
                    the future of on-demand rides, Godide is here to enhance
                    your riding experience.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="wrap_img_content">
                  <figure>
                    <img src={aboutimg} alt="" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="wrapper_Service spacing" id="service">
        <div className="container">
          <div className="wrap_service">
            <div className="title_wrap">
              <h2 className="title_h2">One App For All Your Needs</h2>
              <p className="custom_p">
                Enjoy all the services you need at your fingertips. Our app
                allows access to a wide range of services in one place to bring
                convenience to your life.
              </p>
            </div>
            <div className="row">
              {array?.map((data) => (
                <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                  <div className="_card" key={data.id}>
                    <figure>
                      <img src={data.img} alt="" />
                    </figure>
                    <h4>{data.name}</h4>
                    <p className="custom_ps">{data.para}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      <section className="wrapper_testimonial spacing" id="testimonial">
        <div className="container">
          <div className="wrap_testimonial">
            <div className="wrap_content">
              <span>Testimonial</span>
              <h2 className="title_h2">Real Results, Real Reviews</h2>
            </div>
            <Slider {...settings}>
              {crousal?.map((data) => (
                <div className="testi_user">
                  <figure>
                    <img src={data.img} alt="" />
                  </figure>
                  <div className="text_cnt">
                    <p>{data.para}</p>
                    <p>{data.name}</p>
                    <span>{data.address}</span>
                    <img className="star_set" src={star} alt="" />
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
      </section>
      <section className="wrapper_how_it_works spacing">
        <div className="container">
          <div className="wraptabs">
            <div className="wrap_work">
              <h2 className="title_h2">How it Works</h2>
              <p className="custom_p">
                Book Easily, Ride with Comfort, and Pay Directly with 100%
                Safety.
              </p>
            </div>
            <div className="wrapper_cstm_tabers">
              <ul>
                <li
                  className={propertyTab === "Pre-Order" ? "active" : ""}
                  onClick={() => setPropertyTab("Pre-Order")}
                >
                  Rider
                </li>
                <li
                  className={propertyTab === "Orders" ? "active" : ""}
                  onClick={() => setPropertyTab("Orders")}
                >
                  Driver
                </li>
              </ul>
            </div>
          </div>
          <div className="tabs_show">
            {propertyTab === "Pre-Order" && (
              <div className="row">
                {rideArray?.map((data) => (
                  <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div className="inner_card" key={data.id}>
                      <img src={data.img} alt="" />
                      <h5>{data.name}</h5>
                      <p>{data.para}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
            {propertyTab === "Orders" && (
              <div className="row">
                {driverArray?.map((data) => (
                  <div className="col-lg-4 col-md-4 col-sm-4 col-12">
                    <div className="inner_card" key={data.id}>
                      <img src={data.img} alt="" />
                      <h5>{data.name}</h5>
                      <p>{data.para}</p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </section>
      <section className="wrapper_safety spacing">
        <div className="container">
          <div className="wrap_safety">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="card_left pe-4">
                  <h2 className="tittle_h2">We Care About Your Safety</h2>
                  <ul>
                    {weArray?.map((data) => (
                      <li key={data.id}>
                        <img src={data.img} alt="" />
                        <h5>{data.name}</h5>
                        <p className="custom_p">{data.para}</p>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="card_right">
                  <figure>
                    <img src={ridesafety} alt="" />
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="wrapper_about wrapper_concept spacing">
        <div className="container">
          <div className="wrap_about">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="wrap_img_content">
                  <figure>
                    <img src={conceptimg} alt="" />
                  </figure>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="wrap_content ps-4">
                  <h2 className="title_h2">Redefining Corporate Transport</h2>
                  <p className="custom_p">
                    Godide also provides employee transportation services using
                    different 4 and 7-seaters. Our service ensures that our
                    clients arrive punctually, and comfortably with peace of
                    mind. We are reshaping the future of corporate transport by
                    streamlining the process through hassle-free scheduling,
                    routing, and billing. We offer a premium and professional
                    service to clients or business partners and we also manage
                    company-owned or leased vehicles for various business
                    purposes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="wrapper_faq spacing" id="faq">
        <div className="container">
          <div className="wrap_faq">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="wrap_content pe-4">
                  <span>Faq's</span>
                  <h2 className="title_h2">Frequently Asked Questions</h2>
                  <p className="custom_p">
                    Have some questions? Explore these Frequently Asked
                    Questions to get answers to your queries.
                  </p>
                </div>
              </div>
              <div className="col-lg-6 col-md-6 col-sm-6 col-12">
                <div className="accordian">
                  <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <p>
                          How can I share my ride details with anyone in the
                          Godide app?
                        </p>
                        <span>
                          <MdArrowDropDown />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        You can share your ride details in the Godide app by
                        clicking on the 'Share Trip' option. Select a contact or
                        enter a phone number or email. You can also send
                        tracking links via SMS or social media.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        <p>
                          Can Godide create a ride when no slots are available?
                        </p>
                        <span>
                          <MdArrowDropDown />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        Godide app can offer you alternatives when no slots are
                        available. You can join a waitlist for when a driver
                        becomes available, and schedule rides for a later time.
                        The app can also suggest alternative transportation
                        options like public transport.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        <p>
                          Can I choose the type of car for my ride in Godide
                          App?
                        </p>
                        <span>
                          <MdArrowDropDown />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        Yes, the Godide app offers different vehicle options
                        from a wide range of vehicles such as economy, premium,
                        and SUV. You can choose the car type before booking your
                        ride.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        <p>What if I left something in the car?</p>
                        <span>
                          <MdArrowDropDown />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        If you've lost your item in the car during your ride,
                        you can contact the driver directly through the app to
                        arrange a return. When you are unable to reach the
                        driver, call our support team for assistance.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                      <Accordion.Header>
                        <p>Does Godide operate 24/7?</p>
                        <span>
                          <MdArrowDropDown />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        Yes, Godide operates 24/7 to provide you with seamless
                        and comfortable journeys at any time of the day or
                        night.
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="5">
                      <Accordion.Header>
                        <p>How do I become a Godide driver?</p>
                        <span>
                          <MdArrowDropDown />
                        </span>
                      </Accordion.Header>
                      <Accordion.Body>
                        You can become a Godide driver by visiting the 'Drive
                        with Us' section of our website or mobile app. Fill out
                        the application form, submit the required documents, and
                        appear for background verification. If the application
                        is accepted, you can become an approved Godide driver.
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="wrapper_riding_business spacing">
        <div className="container">
          <div className="warp_business">
            <div className="row">
              <div className="col-lg-6 col-md-5 col-sm-4 col-12">
                <div className="wrap_left">
                  <figure>
                    <img src={mobileimg} alt="" />
                  </figure>
                </div>
              </div>
              <div className="col-lg-6 col-md-7 col-sm-8 col-12">
                <div className="wrap_title">
                  <h2 className="title_h2">
                    Download Our App For Convenient and Safe Journeys
                  </h2>
                  <p>
                    Your best ride is just a tap away from you. Download the
                    Godide app from Google Play or the App Store to enjoy
                    comfortable, fast, and safe rides.
                  </p>
                  <div className="wrap_app_redirection">
                    <Link
                      to={
                        "https://play.google.com/store/apps/details?id=com.ripenapps.godideride&hl=en"
                      }
                      target="_blank"
                    >
                      <img src={andriodimg} alt="" />
                    </Link>
                    <Link
                      to={"https://apps.apple.com/in/app/godiderider/id6504527583"}
                      target="_blank"
                    >
                      <img src={iosimg} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Home;
